<template>
  <v-app>
    <router-view />
    <BaseSnackbar
      v-model="showToastMessage"
      :color="snackBarColor"
      :message="snackbarMessage"
      :elevation="0"
    />
    <BaseLoader :isLoader="showLoader" />
  </v-app>
</template>

<script>
import { bus } from "@/main.js";

export default {
  name: "mainApp",
  data: () => ({
    showToastMessage: false,
    snackBarColor: "primary",
    snackbarMessage: "",
    showLoader: false,
  }),
  mounted() {
    bus.$on("showToastMessage", ({ color, message }) => {
      this.snackBarColor = color;
      this.snackbarMessage = message;
      this.showToastMessage = true;
    });
    bus.$on("showLoader", (value) => {
      this.showLoader = value;
    });
  },
  beforeDestroy() {
    bus.$off("showToastMessage");
    bus.$off("showLoader");
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/global.scss";

.v-application {
  font-family: $body-font-family !important;
}
</style>
